import React, { useRef } from "react";
import { Form, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Container, InputGroup, Label } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import "./TotalHours.css";
import moment from "moment";
import CustomReactSelect from "../../components/CustomReactSelect";
import ButtonLoader from "../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../ticketModule/variables/ListingVariables";

const customStyles = {
	control: (provided) => ({
		...provided,
		border: "none",
	}),
};

const ResHoursTRangeForm = (props) => {
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);
	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<Container fluid className="p-0">
			<Form>
				<Label className="select-criteria-form-title" sm={12}>
					Report - Display total hours accumulated on per task basis
					in a time range
				</Label>
				<Form.Group className="mb-0">
					<Row className="emp-row align-items-center">
						<Col lg={2}>
							<Form.Label className="mb-0 label">
								Select Employee
							</Form.Label>
						</Col>
						<Col lg={10}>
							<CustomReactSelect
								options={props.allEmployees}
								onChange={(obj) => props.getEmpId(obj)}
								isSearchable={false}
								styles={customStyles}
								className="select-employee"
								placeholder="Select"
							/>
						</Col>
					</Row>
				</Form.Group>
				<Form.Group className="mb-0">
					<Row className="date-range-row align-items-center">
						<Col lg={2}>
							<Form.Label className="mb-0 label">
								Start Date
							</Form.Label>
						</Col>
						<Col lg={4}>
							<InputGroup className="datepicker-wrapper">
								<DatePicker
									showYearDropdown
									showMonthDropdown
									dateFormatCalendar=" " //for title
									className="datepicker"
									clearIcon={false}
									calendarIcon={false}
									isOpen={props.startDateCalender}
									maxDate={new Date()}
									dateFormat="DD/MM/YYYY"
									onChange={props.startDateHandleChange}
									value={moment(props.startDate).format(
										"DD/MM/YYYY"
									)}
									ref={startDatepickerRef}
								/>
								<FontAwesomeIcon
									icon={faCalendarAlt}
									className="calender-icon"
									color="keppel"
									onClick={() => openStartDatepicker()}
								/>
							</InputGroup>
						</Col>
						<Col lg={2}>
							<Form.Label className="mb-0 label">
								End Date
							</Form.Label>
						</Col>
						<Col lg={4}>
							<InputGroup className="datepicker-wrapper">
								<DatePicker
									showYearDropdown
									showMonthDropdown
									dateFormatCalendar=" " //for title
									className="datepicker"
									clearIcon={false}
									calendarIcon={false}
									isOpen={props.endDateCalender}
									onChange={props.endDateHandleChange}
									maxDate={new Date()}
									minDate={props.startDate}
									value={moment(props.endDate).format(
										"DD/MM/YYYY"
									)}
									ref={endDatepickerRef}
								/>
								<FontAwesomeIcon
									icon={faCalendarAlt}
									className="calender-icon"
									color="keppel"
									onClick={() => openEndDatepicker()}
								/>
							</InputGroup>
						</Col>
					</Row>
				</Form.Group>
				<Form.Group>
					<Row className="mt-3 mb-4 btns-row">
						<Col lg={8}></Col>
						<Col className="align-items-center d-flex btns-col">
							<input
								type="submit"
								className="submit-report mb-1"
								onClick={props.clicked}
								value=" Run report"
							/>
							<ButtonLoader
								className={ExcelBtnClassName}
								onClick={props.exportToExcel}
								disabled={
									!props.data.length || props.showBtnLoading
								}
								btnTitle={ExcelBtnTitle}
								showBtnLoading={props.showBtnLoading}
							/>
						</Col>
					</Row>
				</Form.Group>
			</Form>
		</Container>
	);
};

export default ResHoursTRangeForm;
